import { MatDialogConfig } from '@angular/material/dialog';
import { MessageDialogData } from './message-dialog-data';

export class ConfirmDialogConfig extends MatDialogConfig<MessageDialogData> {
  constructor(
    message = "Sei sicuro di voler procedere con l'operazione?",
    title = 'Attenzione',
    icon = 'delete',
    dialogClose = true,
    buttonConfirmText = 'Si',
    buttonCancelText = 'No'
  ) {
    super();
    this.data = {
      title: title,
      message: message,
      icon: icon,
      buttonConfirmText: buttonConfirmText,
      buttonCancelText: buttonCancelText,
      confirmButtonColor: 'accent',
      cancelButtonColor: '' as any,
      dialogClose: dialogClose,
    };
  }
}
